import { Injectable } from '@angular/core';
import { SingletonServiceGuard } from '@lsq-frontend/angular-shared/features/generic-get-services';
import { UserService } from '@lsq-frontend/angular-shared/features/user-service';
import { IDateRange } from '@lsq-frontend/common-ui';

export class ReportSavedDateFilterNames {
    public static readonly AccountOverviewByDateReport = 'OverviewByDateSavedDateFilter';
    public static readonly AgingReport = 'agingReportSavedDateFilter';
    public static readonly AgingByCustomerReport = 'agingByCustomerReportSavedDateFilter';
    public static readonly PurchasesReport = 'purchasesReportSavedDateFilter';
    public static readonly PurchasesByCustomerReport = 'purchasesByCustomerReportSavedDateFilter';
    public static readonly CollectionsReport = 'collectionsReportSavedDateFilter';
    public static readonly CollectionsByCustomerReport =
        'collectionsByCustomerReportSavedDateFilter';
    public static readonly IneligiblesReport = 'ineligiblesReportSavedDateFilter';
    public static readonly IneligiblesByCustomerReport =
        'ineligiblesByCustomerReportSavedDateFilter';
    public static readonly FundingsReport = 'fundingsReportSavedDateFilter';
    public static readonly CreditRequestHistoryReport = 'creditRequestHistoryReportSavedDateFilter';
    public static readonly InvoiceUploadHistoryReport = 'invoiceUploadHistoryReportSavedDateFilter';
}

@Injectable({ providedIn: 'root' })
export class SavedDateFilterService {
    public agingReportSavedDateFilter: Date;
    public agingByCustomerReportSavedDateFilter: Date;
    public purchasesReportSavedDateFilter: IDateRange;
    public purchasesByCustomerReportSavedDateFilter: IDateRange;
    public collectionsReportSavedDateFilter: IDateRange;
    public collectionsByCustomerReportSavedDateFilter: IDateRange;
    public ineligiblesReportSavedDateFilter: Date;
    public ineligiblesByCustomerReportSavedDateFilter: Date;
    public fundingsReportSavedDateFilter: IDateRange;
    public creditRequestHistoryReportSavedDateFilter: IDateRange;
    public invoiceUploadHistoryReportSavedDateFilter: IDateRange;

    constructor(private _userService: UserService) {
        SingletonServiceGuard.register('SavedDateFilterService');
        this._userService.logout$.pipe().subscribe(() => {
            this.clearAll();
        });
    }

    public clearAll(): void {
        this.agingReportSavedDateFilter = undefined;
        this.agingByCustomerReportSavedDateFilter = undefined;
        this.purchasesReportSavedDateFilter = undefined;
        this.purchasesByCustomerReportSavedDateFilter = undefined;
        this.collectionsReportSavedDateFilter = undefined;
        this.collectionsByCustomerReportSavedDateFilter = undefined;
        this.ineligiblesReportSavedDateFilter = undefined;
        this.ineligiblesByCustomerReportSavedDateFilter = undefined;
        this.fundingsReportSavedDateFilter = undefined;
        this.creditRequestHistoryReportSavedDateFilter = undefined;
        this.invoiceUploadHistoryReportSavedDateFilter = undefined;
    }

    public clearCustomerReports(): void {
        this.agingByCustomerReportSavedDateFilter = undefined;
        this.purchasesByCustomerReportSavedDateFilter = undefined;
        this.collectionsByCustomerReportSavedDateFilter = undefined;
        this.ineligiblesByCustomerReportSavedDateFilter = undefined;
    }
}
